
import { config } from "@backstagex/core/src/config";

const fields = [
  {
    type: "bsx-input",
    inputType: "text",
    label: "中文姓名",
    model: "name",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "text",
    label: "英文姓名",
    model: "name_en",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-select",
    label: "中文職稱",
    model: "title",
    required: false,
    values: [
      { id: "醫師", name: "醫師" },
      { id: "醫學博士", name: "醫學博士" },
      { id: "中醫師", name: "中醫師" },
      { id: "牙科醫師", name: "牙科醫師" },
      { id: "牙醫碩士", name: "牙醫碩士" },
      { id: "牙醫博士", name: "牙醫博士" },
      { id: "聽力師", name: "聽力師" },
    ],
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-select",
    label: "英文職稱",
    model: "title_en",
    required: false,
    values: [
      { id: "MD", name: "MD" },
      { id: "MD, MS", name: "MD, MS" },
      { id: "MD, Ph.D", name: "MD, Ph.D" },
      { id: "DDS", name: "DDS" },
      { id: "DDS, MS", name: "DDS, MS" },
      { id: "DDS, Ph.D", name: "DDS, Ph.D" },
      { id: "MBChB", name: "MBChB" },
    ],
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-select',
    label: '科別',
    model: 'hospital_departments_id',
    required: true,
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/hospital-department-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-upload",
    label: "照片",
    model: "photo",
    kind: "button",
    required: true,
    browse: true,
    preview: true,
    accept: ".jpg,.png",
    folder: "doctor",
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-upload",
    label: "門診表",
    model: "timetable",
    kind: "button",
    required: true,
    browse: true,
    preview: true,
    accept: ".jpg,.png",
    folder: "doctor",
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-textarea",
    inputType: "text",
    label: "學歷",
    model: "edu",
    required: false,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-textarea",
    inputType: "text",
    label: "經歷",
    model: "exp",
    required: false,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-textarea",
    inputType: "text",
    label: "現任",
    model: "serve",
    required: false,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-textarea",
    inputType: "text",
    label: "專長",
    model: "skill",
    required: false,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-textarea",
    inputType: "text",
    label: "專門著作",
    model: "book",
    required: false,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-textarea",
    inputType: "text",
    label: "想說的話",
    model: "say",
    required: false,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-textarea",
    inputType: "text",
    label: "證書",
    model: "cert",
    required: false,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-textarea",
    inputType: "text",
    label: "學會經歷",
    model: "exp2",
    required: false,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-textarea",
    inputType: "text",
    label: "專業認證",
    model: "cert2",
    required: false,
    validator: function () {
      this.validation();
    },
  },
];

export default fields;
